import { CardWithTitle } from '@hivebrite/design-system/Card';
import {
  ContentList,
  CONTENT_TYPES,
} from '@hivebrite/design-system/ContentList';

import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import {
  type Category,
  type DiscussionCard,
} from 'hb-react/frontoffice/apps/Forum/types';
import UserSnapshot from 'hb-react/shared/components/UserSnapshot';

export interface WidgetSideProps {
  category: Category;
  discussions: Array<DiscussionCard>;
}

const displayFields = {
  [CONTENT_TYPES.FORUM]: { author: true, content: true, group: true },
};

const UserInformationWrapper = ({
  children,
  id,
}: {
  children?: React.ReactNode;
  id: number | string;
}) => <UserSnapshot userId={Number(id)}>{children}</UserSnapshot>;

const WidgetSide = ({ category, discussions }: WidgetSideProps) => {
  const { configUrls } = useForumContext();

  const data = discussions.map(
    // Remove comments & likes since they are not used in the ContentList
    ({
      id,
      title,
      user,
      comments,
      likes,
      content,
      stripped_content: strippedContent,
      ...rest
    }) => ({
      contentType: CONTENT_TYPES.FORUM,
      hasUncroppedName: true,
      name: title,
      path: configUrls.discussionUrl(id),
      author: {
        ...user,
        photoThumbUrl: user.photo_thumb_url,
        path: Routes.user_path(user.id),
      },
      content: strippedContent,
      ...rest,
    }),
  );

  return (
    <CardWithTitle title={category.name}>
      <ContentList
        data={data}
        displayFields={displayFields}
        UserInformationWrapper={UserInformationWrapper}
      />
    </CardWithTitle>
  );
};

export default WidgetSide;
